(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoBachilleratoService', ReporteEvaluativoBachilleratoService);

    ReporteEvaluativoBachilleratoService.$inject = ['$resource'];

    function ReporteEvaluativoBachilleratoService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteBachillerato:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteBachillerato:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteBachillerato:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteBachillerato:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteBachillerato:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
